import moment from "moment";
import _ from "lodash";
import { CARACTERE_ESPECIAL_URL_ID_EXAME } from "./Constantes";

export const formatarCampoTextoLetrasNumeros = str => {
  return str ? str.replace(/[^A-Za-z0-9À-ú´`~^' .]/gi, "") : "";
};

export const formatarData = (data, hora = null, formatoString = false) => {
  if (!hora) {
    return data ? moment(data).format("DD/MM/YYYY") : null;
  }

  if (formatoString) {
    return data ? `${moment(data).format("DD/MM/YYYY")} ${hora}` : null;
  }

  hora = new Date(hora);

  return data
    ? `${moment(data).format("DD/MM/YYYY")} ${hora.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      })}`
    : null;
};

export const formatarDataHora = data => {
  return moment(data).format("DD/MM/YYYY [ás] H:mm:ss");
};

export const transformaBase64emMb = base64String => {
  const stringLength = base64String.length - "data:image/png;base64,".length;
  const sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  const sizeInKb = sizeInBytes / 1000;
  return sizeInKb / 1024;
};

export const limitarTexto = (texto, tam, sulfixo) => {
  return _.truncate(texto, {
    length: tam,
    omission: sulfixo
  });
};

export const removeAcentoEColocarMaiusculo = text => {
  const palavra = text
    .toUpperCase()
    .replace(/^[^A-Z0-9]+/gi, "")
    .replace(new RegExp("[ÁÀÂÃ]", "gi"), "A")
    .replace(new RegExp("[ÉÈÊ]", "gi"), "E")
    .replace(new RegExp("[ÍÌÎ]", "gi"), "I")
    .replace(new RegExp("[ÓÒÔÕ]", "gi"), "O")
    .replace(new RegExp("[ÚÙÛ]", "gi"), "U")
    .replace(new RegExp("[Ç]", "gi"), "C");
  return palavra;
};

export const removerBarraNoIdExame = idExame => {
  return idExame.replace("/", CARACTERE_ESPECIAL_URL_ID_EXAME);
};

export const restaurarBarraNoIdExame = idExame => {
  return idExame.replace(CARACTERE_ESPECIAL_URL_ID_EXAME, "/");
};

export const prepararConteudoValido = valor => {
  if (valor && valor.length > 0) {
    const valorAlterado = valor.replace(/<\/?(p|br...)\b[^<>]*>/g, "").trim();

    return valorAlterado.length > 0 ? valorAlterado : null;
  }
  return null;
};

export const prepararAtributosRetorno = (resposta, preVisualizacao = false) => {
  const [...exameAtributos] = resposta.data.exameAtributos;
  const atributoArea = exameAtributos.find(atributo => atributo.descricao.trim() === "Área");

  const atributosVisiveis = exameAtributos.filter(atributo => {
    let atributoVisivel = true;
    if (preVisualizacao) {
      atributoVisivel = atributo.descricao.trim() !== "Área";
    } else {
      atributoVisivel =
        (prepararConteudoValido(atributo.valor) !== null ||
          prepararConteudoValido(atributo.valorHtml) !== null ||
          atributo.possuiAnexos) &&
        atributo.descricao.trim() !== "Área";
    }
    return atributoVisivel;
  });

  return resposta && resposta.data
    ? {
        ...resposta.data,
        listaAtributosFormatados: {
          atributosVisiveis,
          atributoArea
        }
      }
    : null;
};

export const obterMnemonicoIdExame = idExame => {
  if (!idExame) return "";

  const array = idExame.split("||");

  return array[1];
};

export const toTitleCase = str => {
  if (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  return "";
};

export const base64ParaBlob = (b64Data, tipoDeConteudo = "", tamanhoBloco = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += tamanhoBloco) {
    const bloco = byteCharacters.slice(offset, offset + tamanhoBloco);
    const byteNumbers = new Array(bloco.length);
    for (let i = 0; i < bloco.length; i++) {
      byteNumbers[i] = bloco.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: tipoDeConteudo });
};

export const dowloadPdf = (pdfBase64, nomeArquivo = "documento.pdf") => {
  if (!pdfBase64) return;

  const elemento = document.createElement("a");
  const blob = base64ParaBlob(pdfBase64, "application/pdf");
  elemento.href = URL.createObjectURL(blob);
  elemento.download = nomeArquivo;
  elemento.click();
  elemento.remove();
};

export const formatarDataHoraString = dataHora => {
  if (!dataHora) {
    return null;
  }

  return `${moment(dataHora).format("DD/MM/YYYY")} às ${moment(dataHora).format("HH:mm")}`;
};

export const obterApelidoEmpresaRota = rota => {
  const arrayParams = rota.split("/").filter(function(i){return i});
  if (rota.includes("busca")) {
    return arrayParams[arrayParams.length - 1];
  } else if (!rota.includes("multipla") && rota.includes("visualizacao")) {
    return rota.includes("/?") ? arrayParams[arrayParams.length - 3] : arrayParams[arrayParams.length - 2];
  } 
};

export const ObterFraseTempoJejum = valor => {
  let fraseJejum = "";

  const valoresJejum = valor.split(";");

  if (valoresJejum.length === 1) {
    fraseJejum = valoresJejum[0];
  } else if (valoresJejum.length >= 3) {
    fraseJejum = fraseJejum.concat(
      valoresJejum[0],
      " de no mínimo ",
      valoresJejum[1],
      " ",
      valoresJejum[2]
    );

    if (valoresJejum.length > 3) {
      fraseJejum = fraseJejum.concat(" e no máximo ", valoresJejum[3], " ", valoresJejum[4]);
    }
  }

  return fraseJejum;
};

export const AgruparListaPorChave = function (xs, key) {
  return xs.reduce(function (rv, x) {
    const valor = (rv[x[key]] = rv[x[key]] || []);
    valor.push(x);
    return rv;
  }, {});
};

export const ObterMnemonicoMaterial = idExame => {
  if (idExame) {
    const partesId = idExame?.split("||");
    return partesId[0] || "";
  }
};

export const ObterNomeExamePerfil = (exame, idExame, estaAutenticado) => {
  let nomeExame = exame;
  if (!estaAutenticado) {
    nomeExame += " [" + ObterMnemonicoMaterial(idExame) + "]";
  } else {
    nomeExame +=
      " [" + ObterMnemonicoMaterial(idExame) + " | " + obterMnemonicoIdExame(idExame) + "]";
  }

  return nomeExame;
};
